import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

/**
 * Duplicate a form template
 */
export async function duplicateFormsTemplate(
  templateId: string
): Promise<{ success: boolean; data?: { formsTemplate: { id: string } } }> {
  try {
    const res = await fetcher(`${BASE_URL}/${templateId}/duplicate`, {
      method: 'POST',
    });

    if (!res.ok) {
      console.error('Failed to duplicate form template:', await res.text());
      return { success: false };
    }

    const responseData = (await res.json()) as {
      formsTemplate: { id: string };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error('Error duplicating form template:', err);
    return { success: false };
  }
}
